export default __webpack_public_path__ + "static/media/manage-users-hover.ecd9129d.svg";